/// <amd-module name="Build/Common/Library/StateHandler" />
import { NavConstants } from "Build/Common/Library/Constants";
import { PipelinesStateData } from "Build/Common/Library/PipelinesStateData";
import { getSingletonManager } from "Build/Common/Library/SingletonManager";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";

export function clearTreeState(pageContext: IVssPageContext) {
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");

    let currentState = historyService.getState();
    if (currentState.hasOwnProperty(NavConstants.treeState)) {
        // historyService.replaceState destroys URL hash (e.g. when navigating to Start Right extension which has different 
        // hash values depending on the sub-section), so if it's not really necessary, let's skip it.
        delete currentState[NavConstants.treeState];
        historyService.replaceState(currentState);
    }
    
    getSingletonManager().remove<PipelinesStateData>(PipelinesStateData.key);
}

export function updateTreeStateSettings(pageContext: IVssPageContext, expandedFolders: string) {
    if (isPipelinesView(pageContext))
    {
       const currentStore = EnsurePipelinesStateDataInitialized();
       currentStore.updateTreeData(expandedFolders);
    }
}

export function updateTreeStateUrl(pageContext: IVssPageContext, expandedFolders: string) {
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    const url: string  = historyService.generateUrl({ treeState: expandedFolders });
    historyService.replaceState(undefined, url);
}

export function getTreeState(pageContext: IVssPageContext) : string {
    let treeState = "";
    let currentStore = getPipelinesStateData();
   
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    treeState = historyService.getState()[NavConstants.treeState] || "";

    if (!treeState)
    {
        if (currentStore)
        {
            treeState = currentStore.treeData;

            // set the treeState in the URL if not there
            if (treeState)
            {
                updateTreeStateUrl(pageContext, treeState);
            }
        }
    }
    
    if (!currentStore && !treeState)
    {
        clearTreeState(pageContext);
    }

    if (!currentStore)
    {
        initializePipelinesStateData();
    }
   
    return treeState;
}

export function clearTreeStateOnUnmount(pageContext: IVssPageContext) {
    if (!isPipelinesView(pageContext))
    {
        clearTreeState(pageContext);
    }
}

function isPipelinesView(pageContext: IVssPageContext): boolean {
    const url = window.location.href;
    const isPipelinesView = url.lastIndexOf("_build") >= 0 || url.lastIndexOf("build-") >= 0 ? true : false;
    return isPipelinesView;
}

function EnsurePipelinesStateDataInitialized(): PipelinesStateData {
    let currentStore = getPipelinesStateData();
    if (!currentStore)
    {
        currentStore = initializePipelinesStateData();
    }

    return currentStore;
}

function getPipelinesStateData(): PipelinesStateData | null {
    return getSingletonManager().get<PipelinesStateData>(PipelinesStateData.key);
}

function initializePipelinesStateData() : PipelinesStateData {
        const currentStore = new PipelinesStateData();
        getSingletonManager().add<PipelinesStateData>(PipelinesStateData.key, currentStore);
        return currentStore;
}